import React, { Component } from "react";
import * as actions from "../../../actions/other_info/group_name.action";
import { connect } from "react-redux";
import moment from "moment";
import { Formik } from "formik";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardBody,
  Modal,
  ModalBody,
  ModalHeader,
  FormInput,
  FormTextarea
} from "shards-react";
import { httpClient } from "../../../utils/HttpClient";
import { server } from "../../../constants";
import Swal from "sweetalert2";
import ContentPagination from "../../Layout/Pagination";

class GroupName extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupNames: [],
      currentPage: 0,
      totalPages: 1,
      perPage: 10,
      loading: false,
      ModalOpen: false,
      add_update: "",
      group_id: "",
      group_name: "",
      group_desc: "",
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  async componentDidMount() {
    await this.getGroupNames(this.state.currentPage);
  }

  async getGroupNames(page) {
    this.setState({ loading: true });

    await this.props.getGroupName(page);

    const { groupNames, total, isFetching } = this.props.groupNamesReducer;

    const totalPages = Math.ceil(total / this.state.perPage);

    if (!isFetching && groupNames) {
      this.setState({
        groupNames,
        totalPages,
      });
    }

    this.setState({ loading: false });
  }

  btnFormatter(row) {
    return (
      <React.Fragment>
        <a
          type="button"
          className="btn btn-sm btn-success text-white"
          onClick={(e) => this.toggleModal(row, "edit")}
        >
          แก้ไข
        </a>
        <span style={{ color: "grey" }}> | </span>
        <a
          onClick={() => {
            Swal.fire({
              title: "ยืนยันการลบกลุ่มผู่้เข้าประชุม?",
              text: "เมื่อลบข้อมูลแล้วจะไม่สามารถนำกลับมาได้",
              type: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes, delete it!",
              cancelButtonText: "No, cancel!",
            }).then((result) => {
              if (result.value) {
                this.deleteGroupName(row.id);
              }
            });
          }}
          type="button"
          className="btn btn-sm btn-danger"
          style={{ color: "white" }}
        >
          ลบ
        </a>
      </React.Fragment>
    );
  }

  async deleteGroupName(id) {
    await this.props.deleteGroupName(id, this.state.currentPage);
    setTimeout(() => {
      this.getGroupNames(this.state.currentPage);
    }, 100);
  }

  formatDateTime(value) {
    if (value) {
      return moment(value).format("DD/MM/YYYY HH:mm:ss");
    }
  }

  toggleModal(value, action) {
    if (action === "edit") {
      let groupName = "";
      let groupID = "";
      let groupDesc = "";

      if (value.group_name) groupName = value.group_name;
      if (value.id) groupID = value.id;
      if (value.group_desc) groupDesc = value.group_desc;

      this.setState({
        ModalOpen: !this.state.ModalOpen,
        group_name: groupName,
        group_id: groupID,
        group_desc: groupDesc,
        add_update: action,
      });
    } else {
      this.setState({
        group_name: "",
        group_desc: "",
        ModalOpen: !this.state.ModalOpen,
        add_update: action,
      });
    }
  }

  closeModal() {
    this.setState({
      ModalOpen: !this.state.ModalOpen,
    });
  }

  renderTable = () => {
    return (
      <React.Fragment>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th className="text-center">ชื่อกลุ่มผู้เข้าประชุม</th>
              <th className="text-center">รายละเอียดกลุ่ม</th>
              <th className="text-center">รายชื่อสมาชิกในกลุ่ม</th>
              <th className="text-center">วันที่สร้าง</th>
              <th className="text-center">วันที่แก้ไขล่าสุด</th>
              <th className="text-center">แก้ไข/ลบ</th>
            </tr>
          </thead>
          <tbody>
            {this.state.groupNames.map((item, index) => {
              return (
                <tr key={item.id}>
                  <td className="text-center align-middle">{item.group_name}</td>
                  <td className="text-center align-middle">{item.group_desc}</td>


                <td style={{ textAlign: "center" }}>
                  <button
                    type="button"
                    className="btn btn-sm btn-warning mr-2"
                    onClick={() =>
                      this.props.history.push(
                        `/group/detail/${item.id}`
                      )
                    }
                  >
                    รายชื่อสมาชิกในกลุ่ม
                  </button>
                </td>

                  <td className="text-center align-middle">
                    {this.formatDateTime(item.createdAt)}
                  </td>
                  <td className="text-center align-middle">
                    {this.formatDateTime(item.updatedAt)}
                  </td>
                  <td className="text-center align-middle" width="250">
                    {this.btnFormatter(item)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <Modal open={this.state.ModalOpen} toggle={this.toggleModal}>
          <ModalHeader>เพิ่ม/แก้ไข กลุ่มผู้เข้าประชุม</ModalHeader>
          <ModalBody>
            <Formik
              initialValues={{
                id: this.state.group_id,
                group_name: this.state.group_name,
                group_desc: this.state.group_desc,
              }}
              render={({ values, handleChange }) => (
                <React.Fragment>
                  <Row form>
                    <Col md="12" className="form-group">
                      <label>ชื่อกลุ่ม</label>
                      <FormInput
                        name="group_name"
                        id="group_name"
                        onChange={handleChange}
                        value={values.group_name}
                      />
                    </Col>
                  </Row>

                  <Row form>
                    <Col md="12" className="form-group">
                      <label>รายละเอียดกลุ่ม</label>
                      <FormTextarea
                        rows="3"
                        name="group_desc"
                        id="group_desc"
                        onChange={handleChange}
                        value={values.group_desc}
                      />
                    </Col>
                  </Row>

                  <div className="text-right">
                    <button
                      type="button"
                      className="btn btn-primary pull-right"
                      onClick={() => {
                        this.addEditGroup(
                          this.state.group_id,
                          values.group_name,
                          values.group_desc
                        );
                      }}
                      style={{
                        marginRight: 10,
                        color: "white",
                        width: 100,
                      }}
                    >
                      บันทึก
                    </button>
                    <button
                      onClick={(e) => this.closeModal()}
                      type="Button"
                      className="btn btn-danger pull-right"
                      style={{ color: "white", width: 100 }}
                    >
                      ยกเลิก
                    </button>
                  </div>
                </React.Fragment>
              )}
            />
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  };

  async addEditGroup(id, name, desc) {
    if (name) {

      let dateTime = new Date();
      dateTime = moment(dateTime).format("YYYY-MM-DD HH:mm:ss");

      let data = {};
      data = { group_name: name, group_desc:desc, updatedAt: dateTime };

      let response = "";

      if (this.state.add_update === "add") {
        response = await httpClient.post(`${server.GROUP_NAME_URL}`, data, {
          headers: {
            "Content-Type": "application/json",
          },
        });
      } else if (this.state.add_update === "edit") {
        response = await httpClient.patch(
          `${server.GROUP_NAME_URL}` + "/" + `${id}`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      }

      if (response.status === 201 || response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "ข้อมูลถูกบันทึกเรียบร้อยแล้ว",
          showConfirmButton: false,
          timer: 1500,
        });

        this.setState({
          ModalOpen: false,
        });

        this.getGroupNames(this.state.currentPage);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "เกิดข้อผิดพลาดในการบันทึกข้อมูล!",
          timer: 1500,
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        text: "กรุณากรอก ชื่ออาคาร",
        timer: 1500,
      });
    }
  }

  changePage(page) {
    this.setState({ currentPage: page });
    this.getGroupNames(page);
  }

  render() {
    return (
      <Container fluid>
        <div style={{ padding: 20 }}>
          <Card className="mb-3">
            <CardHeader className="border-bottom">
              <Row>
                <Col sm="6" className="d-flex mb-2 mb-sm-0">
                  <h6 className="mt-1">กลุ่มผู้เข้าประชุม</h6>
                </Col>
                <Col>
                  <Button
                    onClick={(e) => this.toggleModal(null, "add")}
                    className=" btn btn-md d-flex ml-auto mr-sm-0 mt-3 mt-sm-0"
                  >
                    เพิ่มกลุ่มผู้เข้าประชุม
                  </Button>
                </Col>
              </Row>
            </CardHeader>
            <div
              class={
                "content-loading-wrapper " +
                (this.state.loading ? "loading" : "")
              }
            >
              {this.renderTable()}
            </div>

            <CardBody className="pt-2">
              <nav className="text-right">
                {this.state.groupNames.length > 0 && (
                  <ContentPagination
                    currentPage={this.state.currentPage}
                    totalPages={this.state.totalPages}
                    onPageChange={this.changePage.bind(this)}
                    pageShow={5}
                  />
                )}
              </nav>
            </CardBody>
          </Card>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = ({ groupNamesReducer }) => ({
  groupNamesReducer,
});

const mapDispatchToProps = {
  ...actions,
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupName);
